/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

import { useTranslation } from "react-i18next";

// Settings page components
import MDInput from "components/MDInput";
import NotificationsTable from "./notificationsTable";

// NewUser page components
function ApartmentNotificationsModal({ apartmentData, handleEdit, handleRemove }) {
  const { t } = useTranslation();
  return (
    <MDBox py={3}>
      <Grid container justifyContent="center" alignItems="center" sx={{ overflow: "visible" }}>
        <Card id="basic-info" sx={{ overflow: "visible" }}>
          <MDBox
            height="4rem"
            bgColor="info"
            variant="gradient"
            coloredShadow="info"
            borderRadius="xl"
            display="flex"
            justifyContent="center"
            alignItems="center"
            color="white"
            mt={-3}
            mx={10}
            px={2}
          >
            {`${t("notifications")} - ${apartmentData.apartmentName}`}
          </MDBox>
          <MDBox pt={3} pb={0} px={3}>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MDInput
                  variant="standard"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  label={t("apartment")}
                  value={apartmentData.apartmentName}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <MDInput
                  variant="standard"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  label={t("project")}
                  value={apartmentData.projectName}
                />
              </Grid>
            </Grid>
          </MDBox>
          <NotificationsTable
            notifications={apartmentData.notifications}
            handleEdit={(data) => {
              handleEdit(data);
            }}
            handleRemove={(data) => {
              handleRemove(data);
            }}
          />
        </Card>
      </Grid>
    </MDBox>
  );
}

ApartmentNotificationsModal.propTypes = {
  apartmentData: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
};

export default ApartmentNotificationsModal;
